import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { content: String }

    loadViewer() { return import("./viewer") }

    async connect() {
        const connection = this.connection = {}
        this.element.textContent = this.contentValue
        try {
            const { createViewer } = await this.loadViewer()
            if (this.connection !== connection) return
            this.element.replaceChildren()
            this.view = createViewer(this.element, this.contentValue)
        } catch (error) {
            if (this.connection === connection) {
                this.element.textContent = this.contentValue
                this.dispatch("error", { detail: { error } })
            }
        }
    }

    disconnect() {
        this.connection = null
        this.view?.destroy()
        this.view = null
        this.element.textContent = this.contentValue
    }
}
